export type Theme = "light" | "dark"

export const THEME_STORAGE_KEY = "mc:theme"

/**
 * Mirrors the inline script in index.html (kept deliberately tiny and
 * duplicated there on purpose: it must run before React loads to avoid a
 * theme flash). This module is the source of truth for every other place
 * in the app that needs to read/change the theme after mount.
 */
export function getStoredTheme(): Theme | null {
  const stored = localStorage.getItem(THEME_STORAGE_KEY)
  return stored === "light" || stored === "dark" ? stored : null
}

export function getSystemTheme(): Theme {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
}

export function getActiveTheme(): Theme {
  return getStoredTheme() ?? getSystemTheme()
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme)
}

export function persistTheme(theme: Theme): void {
  localStorage.setItem(THEME_STORAGE_KEY, theme)
  applyTheme(theme)
}
